export const DEFAULT_FORECAST = {
    spentBudget: 0,
    dayDuration: 0,
    generalUniverse: '-',
    targetUniverse: '-',
    targetUniverseRaw: 0,
    screensQuantity: 0,
    totalImpressions: 0,
    reproductionTime: 0,
    screenTypeDistribution: {},
    generalMetrics: {
        coverage: 0,
        totalImpacts: 0,
        cpm: 0,
        grp: 0,
        frequency: 0,
    },
    targetMetrics: {
        coverage: 0,
        totalImpacts: 0,
        cpm: 0,
        grp: 0,
        frequency: 0,
    },
    coverage: '-',
    coverageAbs: '-',
    targetImpacts: 0,
    totalImpacts: '-',
    adImpressions: '-',
    frequency: '-',
    cpm: '-',
    grp: '-',
    screens: '-',
    duration: '-',
    validScreens: [],
    screensNotUsed: [],
    screensUsed: [],
    notMatchingScreens: [],
    screensWithoutProvider: [],
    screenCountWarnings: [],
    costs: '-',
    cpi: '-',
    impressions: '-',
    isUnderspend: false,
    schedules: [],
    impressionsPerScreen: [],
};
